module.exports = __webpack_public_path__ + "static/media/panse.137024bb.jpeg";